import {computed, type ComputedRef} from "vue";
import {useTimestamp} from "@vueuse/core";
import {useSharedCache} from "@/service/sharedCache.service.ts";

const interval = 5_000 // ms
const globalTimestampKey = Symbol('global-timestamp')

export function useGlobalTimestamp(): ComputedRef<number> {
  const cache = useSharedCache()
  const timestamp = cache.getOrCompute(globalTimestampKey, () => useTimestamp({interval}))
  return computed(() => timestamp.value)
}
